<div class="import-bgm-dialog ui basic segment">
  <form class="content ui form" [formGroup]="importOptionForm">
    <p>Do you want to import all collection of subjects in bgm.tv?</p>
    <div class="field">
      <ui-toggle formControlName="override">Override local favorites</ui-toggle>
    </div>
    <div class="field">
      <ui-toggle formControlName="syncBack">Sync back to bgm.tv</ui-toggle>
    </div>
  </form>
  <div class="footer">
    <button class="ui primary button" (click)="import()">Import</button>
    <button class="ui button" (click)="close()">Cancel</button>
  </div>
</div>
